// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"b4d9ca48","828":"b609e9a4"}[chunkId] + ".chunk.js";
};